export const multiSelectLaraThemeConfig = {
  colorScheme: {
    light: {
      focus: {
        ringShadow: "none",
        borderColor: "{primary-500}",
      },
      disabledBackground: "{gray-50}",
      disabledColor: "{gray-500}",
      borderRadius: "var(--radius-8)",
      borderColor: "{gray-300}",
      shadow: "var(--shadow-xs)",
      placeholderColor: "var(--p-gray-500)",
      chipBorderRadius: "var(--radius-6)",
    },
  },

  css: ({ dt }: any) => `
    .p-multiselect:not(.p-disabled).p-focus, .p-multiselect-open {
      border: 2px solid var(--p-multiselect-focus-border-color);
    }
    .p-multiselect:not(.p-disabled).p-focus.invalid-input, .p-multiselect-open.invalid-input {
      border: 2px solid var(--p-red-500);
    }
    .p-multiselect:not(.p-disabled):hover.invalid-input, .p-multiselect.invalid-input {
      border-color: var(--p-red-300)
    }
    .p-multiselect-label {
      gap: 5px;
    }
    .p-multiselect-sm .p-multiselect-label {
      line-height: var(--line-height-text-24)
    }
    .p-multiselect-sm .p-multiselect-label .p-multiselect-chip-item {
      display: flex;
    }
    .p-multiselect-sm .p-multiselect-label .p-chip {
      padding-block: 1px;
      padding-inline: var(--spacing-8);
      font: var(--font-text-sm-medium);
      background-color: ${dt("primary.100")};
      border: 1px solid ${dt("primary.300")};
      color: ${dt("primary.700")};
      gap: 0;
    }
    .p-multiselect-sm .p-multiselect-label .p-chip:has(.p-chip-remove-icon) {
      padding-inline-end: var(--spacing-6);
    }
    .p-multiselect-sm .p-multiselect-label .p-chip:has(.p-chip-remove-icon) .p-chip-label {
      padding-inline-end: 5px;
    }
    .p-multiselect-sm .p-multiselect-label .p-chip .p-chip-remove-icon {
      display: flex;
      width: fit-content;
      height: fit-content;
    }
    .p-multiselect-dropdown-icon {
      display: flex;
    }
    .p-multiselect-option {
      margin-inline: var(--spacing-6);
      margin-top: 5px;
      line-height: var(--line-height-text-24);
      border-radius: var(--radius-6);
    }
    .p-multiselect-option p-checkbox {
      margin-inline-start: auto;
      order: 1;
    }
    .p-multiselect-option p-checkbox .p-checkbox .p-checkbox-box {
      border: 0px;
      background: transparent;
    }
    .p-multiselect-option p-checkbox .p-checkbox .p-checkbox-box .p-iconwrapper .p-checkbox-icon {
      color: var(--p-primary-600);
    }
  `,
};
/**
 * .p-multiselect-option .p-checkbox-input .p-checkbox-box {
 *        background: transparent;
 *        border: 0;
 *     }
 *     .p-multiselect-option .p-checkbox-input .p-checkbox-box svg {
 *        color: var(--p-primary-600)
 *     }
 */
